(function ($) {
    var win, footer,
        animationTimeout = 400,
        easing = "easeOutQuart";
    function ready() {
        footer = $("#footer");
        win = $(window);
        win.scroll(onWindowScroll);
    }
    function onWindowScroll() {
        if ($(this).scrollTop() < 200) {
            footer.stop(true, false).slideUp(animationTimeout, easing);
        }
        else {
            footer.stop(true, false).slideDown(animationTimeout, easing);
        }
    }
    $(ready);
})(jQuery);
